export const getFileExtension = (fileName) => {
  return fileName.substr(fileName.lastIndexOf(".") + 1);
};
export const getFileName = (fileName) => {
  return fileName.substr(0, fileName.lastIndexOf("."));
};
export const downloadImageByUrl = (url, filename) => {
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
export const toBlob = (url) => {
  return fetch(url).then((response) => response.blob());
};
export const toFormData = (data) => {
  const formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }
  return formData;
};
export const bytesToSize = (bytes, unit = 1024) => {
  if (bytes === 0)
    return "0 Byte";
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const index = Math.floor(Math.log(bytes) / Math.log(unit));
  const roundedValue = Math.round(bytes / Math.pow(unit, index));
  return `${roundedValue} ${sizes[index]}`;
};
export const getImageDimensions = (file) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      resolve({
        height: img.height,
        width: img.width
      });
    };
    img.src = URL.createObjectURL(file);
  });
};
